<div class="leftbar__tabs-content" appLeftbarContent
     [shouldShowSettingsMenu]="false">
</div>

<evc-nav-button type="cta" size="xxl" variant="round" (click)="callToAction.action()" *callToAction>
  <span class="top-cta-label">
      {{callToAction.label | translate }}
  </span>
  <evc-svg-icon size="md" [icon]="'plus'"></evc-svg-icon>
</evc-nav-button>

<div fxLayout="row" class="header-content">
  <div class="settings-title-container">
      <h1>{{'settingsSubject.model' | translate}}</h1>
      @if(!this.isOffline){
        <evc-button
        [icon]="'upload'"
        size="small"
        [buttonStyle]="'neutral'"
        (click)="useApplicationFileManager ? showFileManager(): importbutton.click()"
        [textContent]=" 'settingsSubject.import' | translate"></evc-button>
      }
  </div>
  <input hidden #importbutton type="file" accept=".zip" [(ngModel)]="importFiles"(change)="importSubjectModel($event.target.files)" />
</div>
<div class="content" fxLayout="row">

    <div class="subject-model" fxLayout="column">

        <mat-list>
            <div class="list" *ngFor="let model of modelDataSource.data" [class.selected]="isSelectedModel(model.id)"
                 [ngClass]="{'disabled': !model.isValid}">
                <div class="item-list" mat-list-item
                     fxLayout="row"
                     fxLayoutAlign="space-between center">
                    <div class="title-area" (click)="selectModel(model.id)">
                        {{model.name}}
                    </div>
                    <div class="detail-area" (click)="selectModel(model.id)">
                        <div class="version-label" mat-line>{{'Version: '}}{{model.version}}</div>
                        <div class="date-label" mat-line>{{model.lastUpdateDate | date: 'yyyy/MM/dd'}}</div>
                    </div>
                  @if(isOnPremiseMode){
                    <evc-nav-button
                      [disabled]="!model.isValid"
                      class="tags-action-button delete-button black-icon"
                      [type]="'icon'"
                      [size]="'lg'"
                      [variant]="'semi'"
                      [leftIcon]="'trash-can'"
                      (click)="openDeleteNotSelectedSubjectModelDialog(model.id)">
                    </evc-nav-button>
                  }
                </div>

            </div>
        </mat-list>
    </div>

    <div fxFlex class="subject-model-detail" fxLayout="row wrap" *ngIf="selectedModel">
        <div class="panel subject-panel">
            <div class="panel-menu" fxLayout="row">
                <div class="subject-name-content" [matTooltip]="selectedModel ? selectedModel.name : null" matTooltipPosition="above"
                    matTooltipClass="tooltip-overflow">
                    <h3 class="select-model-name">
                        {{selectedModel ? selectedModel.name : null}}
                    </h3>
                </div>
                <button mat-icon-button class="more-vert-icon" [matMenuTriggerFor]="MatMenu">
                    <mat-icon class="open-list-item-menu">more_vert</mat-icon>
                </button>
                <mat-menu class="three-dot-menu" #MatMenu>
                    <button mat-menu-item (click)="openEditModelDialog()" [disabled]="!selectedModel || isOffline">
                        {{ 'settingsSubject.edit' | translate }}
                    </button>
                    <button *ngIf="!isSafari(browserName)" mat-menu-item (click)="exportSubjectModel()" [disabled]="isOffline">
                        {{ 'settingsSubject.export' | translate }}
                    </button>
                    <button mat-menu-item (click)="openCloneModelDialog()" [disabled]="!selectedModel || isOffline">
                        {{ 'settingsSubject.clone' | translate }}
                    </button>

                  @if(!isOnPremiseMode){
                    <button mat-menu-item (click)="openDeleteSubjectModelDialog(selectedModel)" [disabled]="!(!isOffline || (isOffline && selectedModel?.isOfflineData))">
                      {{ 'settingsSubject.delete' | translate }}
                    </button>
                  }

                  @if(isOnPremiseMode){
                    <button mat-menu-item (click)="openDeleteNotSelectedSubjectModelDialog(selectedModel.id)">
                      {{ 'settingsSubject.delete' | translate }}
                    </button>
                  }

                    <button mat-menu-item (click)="openImageUploadDialog()" [disabled]="isOffline">
                        {{ 'settingsSubject.selectImage' | translate }}
                    </button>
                </mat-menu>
                <div fxFlex *ngIf="isAdmin" class="navigation-div" fxLayout="row" fxLayoutAlign="end end">
                    <div class="navigation-message"
                        *ngIf="!selectedModel.isValid && !selectedModel.hasInspections">
                        <b>{{ 'settingsSubject.navigationMessage' | translate }}
                        </b>
                    </div>
                </div>
            </div>
            <div class="panel-content">

                <div class="subject-cad-toggle">
                    <div #subjectCad class="subject-cad-name" (click)="clickSubjectImageHide()">
                        <mat-icon *ngIf="!isSubjectImageOpen">chevron_right</mat-icon>
                        <mat-icon *ngIf="isSubjectImageOpen">expand_more</mat-icon>
                    </div>
                </div>

                <div class="btn-select-image" *ngIf="(!selectedModel.structImagePath && isSubjectImageOpen) && !isOffline">
                    <button mat-raised-button (click)="openImageUploadDialog()">
                        {{ 'settingsSubject.selectImage' | translate }}
                    </button>
                    <div class="no-image-div">
                        <b>&nbsp; &nbsp; {{ 'settingsSubject.noImage' | translate }}</b>
                    </div>
                </div>

                <div class="subject-cad-wrapper" [ngClass]="{ 'hidden-height': !isSubjectImageOpen, 'hidden-image': !isSubjectImageOpen }">
                    @if(selectedModel.structImagePath) {
                      <!--subject model locations-->
                      <img [src]="selectedModel.structImagePath" class="subject-cad-image" [class.hidden]="!isSubjectImageOpen" alt="dummyImage" />
                      <div class="locations-layer" [class.image-expand]="!isSubjectImageOpen"></div>
                      <div class="locations">
                        <!-- area -->
                        @for(location of selectedModel.locations; track location.identifier) {
                          @if(!isRectInStructImageAllZero(location.rectInStructImage)) {
                            <div class="location-area"
                              [class.locationSelected]="selectedLocation && getPrimaryLocation(selectedLocation.identifier) === location"
                              (click)="selectLocation4FilterImages(location)"
                              [style.top]="location.rectInStructImage.top + '%'"
                              [style.left]="location.rectInStructImage.left + '%'"
                              [style.width]="location.rectInStructImage.width + '%'"
                              [style.height]="location.rectInStructImage.height + '%'">
                              &nbsp;
                            </div>
                          }
                        }
                      </div>
                    }
                </div>
                <div class="subject-no-image" *ngIf="!selectedModel.structImagePath && isSubjectImageOpen">
                    <div *ngIf="isSubjectImageOpen" class="no-image-open">
                        <mat-icon class="no-image-icon material-icons-outlined">hide_image</mat-icon>
                        <span class="no-image-text">{{'settingsSubject.noImg' | translate }}</span>
                    </div>
                </div>
                <div *ngIf="!selectedModel.structImagePath && !isSubjectImageOpen" class="no-image-close"></div>
                <div fxLayout="column">
                    <mat-tab-group [selectedIndex]="tabIndex">
                        <mat-tab [label]="'settingsSubject.tabSerial' | translate: { serialNumberLabel: serialNumberLabel}">
                            <div class="menu-panel-div" fxLayoutAlign="end end">
                                <div class="serial-msg-div" *ngIf="!selectedModel.isValid">
                                    <span>{{ 'settingsSubject.serialMessage' | translate }}</span>
                                </div>
                                <evc-nav-button
                                [leftIcon]="'plus'"
                                type="tertiary"
                                (click)="insertSubject()"
                                [disabled]="!selectedModel || !selectedModel.isValid">
                                   {{ 'settingsSubject.new' | translate }}
                                </evc-nav-button>
                            </div>
                            <mat-table fxFlex class="subject-serial-table" #subjecttable [dataSource]="subjectDataSource">
                                <ng-container matColumnDef="subject">
                                    <mat-header-cell *matHeaderCellDef>{{serialNumberLabel}}</mat-header-cell>
                                    <mat-cell *matCellDef="let row"> {{row.serialNo}}
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="version">
                                    <mat-header-cell *matHeaderCellDef>Version</mat-header-cell>
                                    <mat-cell *matCellDef="let row"> {{row.version}}
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="enabled">
                                    <mat-header-cell *matHeaderCellDef>{{ 'settingsSubject.availability' | translate }}</mat-header-cell>
                                    <mat-cell *matCellDef="let row"> {{ 'settingsSubject.' + (row.isValid ? 'enabled' : 'disabled') |
                                        translate}}
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="action">
                                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                    <mat-cell *matCellDef="let row">
                                        <button *ngIf="!isOffline || (isOffline && row?.isOfflineData)" mat-button color="warn" [id]="row.id"
                                            (click)="openDeleteSubject(row);$event.stopPropagation();">
                                            <mat-icon style="margin: 0;">delete</mat-icon>
                                        </button>
                                    </mat-cell>
                                </ng-container>
                                <mat-header-row *matHeaderRowDef="['subject', 'version', 'enabled', 'action']"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: ['subject', 'version', 'enabled', 'action'];" (click)="updateSubject(row)"
                                    [ngClass]="{'disabled': !row.isValid}">
                                </mat-row>
                            </mat-table>
                            <div class="no-serial-div" *ngIf="!serialFound" fxLayout="row" fxLayoutAlign="center none">
                                {{ 'settingsSubject.noSerialFound' | translate }}</div>
                        </mat-tab>
                        <mat-tab [label]="'settingsSubject.tabStructure' | translate">
                            <div class="locations-setting-area" fxLayout="column" fxLayoutGap="5px">
                                <div class="used-msg-div" *ngIf="selectedModel && selectedModel.hasInspections">
                                    <div class="used-message">&nbsp;&nbsp;{{ 'settingsSubject.usedMessage1' | translate }} &nbsp;</div>
                                    <div class="used-message">&nbsp;&nbsp;{{ 'settingsSubject.usedMessage2' | translate }} &nbsp;</div>
                                </div>
                                <div class="unused-msg-div" fxLayout="row"
                                    *ngIf="selectedModel && !selectedModel.isValid && !selectedModel.hasInspections">
                                    <span>&nbsp;&nbsp; <b>{{ 'settingsSubject.unusedMessage' | translate }}</b></span>
                                </div>

                                <div class="location-button-div" *ngIf="selectedModel">

                                    <button mat-raised-button class="button-padding" [ngClass]="{'disabled': isOffline}" color="primary" [disabled]="isOffline" (click)="openEditLocationDialog(false, null)">
                                        <mat-icon aria-label="">add_box</mat-icon>{{ 'settingsSubject.addLocation' | translate }}
                                    </button>

                                    <button mat-raised-button class="button-padding" [ngClass]="{'disabled': isOffline}" color="primary" [disabled]="isOffline" (click)="validateIsUpdate(false, null, true, false)">
                                        <mat-icon aria-label="">arrow_upward</mat-icon>{{ 'settingsSubject.up' | translate }}
                                    </button>

                                    <button mat-raised-button class="button-padding" [ngClass]="{'disabled': isOffline}" color="primary" [disabled]="isOffline" (click)="validateIsUpdate(false, null, false, false)">
                                        <mat-icon aria-label="">arrow_downward</mat-icon>{{ 'settingsSubject.down' | translate }}
                                    </button>

                                    <button mat-icon-button [matMenuTriggerFor]="ImageMenu" class="button-padding location-button" color="primary">
                                        <mat-icon aria-label="">more_vert</mat-icon>
                                    </button>
                                    <mat-menu #ImageMenu="matMenu">
                                        <button mat-menu-item (click)="validateIsUpdate(true, null, null, false)" [disabled]="isDisabledPasteTopLocation()"
                                            [matTooltip]="getPasteTooltipText()">{{ 'settingsSubject.pasteLocation' | translate }}</button>
                                    </mat-menu>
                                </div>
                                <ng-container *ngIf="!selectedModel">
                                    <div class="location-button-div">
                                        <br>
                                    </div>
                                </ng-container>
                                <div class="location-structure-div" fxLayout="row">
                                    <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="tree-content">
                                        <mat-tree-node *matTreeNodeDef="let subjectLocation" matTreeNodeToggle>
                                            <li (click)="selectLocation4FilterImages(subjectLocation)" class="mat-tree-node" fxLayout="row"
                                                fxFlex
                                                [ngClass]="{'selected': selectedLocation && subjectLocation.identifier === selectedLocation.identifier}">
                                                <mat-icon class="folder-icon-bottom" [ngClass]="{'retention': isRetention(subjectLocation)}">folder</mat-icon>
                                                <span [ngClass]="{'retention': isRetention(subjectLocation)}">{{subjectLocation.name}}</span>
                                                <div fxFlex></div>
                                                <mat-menu #ImageMenu="matMenu">
                                                    <button mat-menu-item (click)="openEditLocationDialog(true, subjectLocation)" [disabled]="isOffline">
                                                        {{'settingsSubject.editLocation' | translate }}</button>
                                                    <button mat-menu-item (click)="openLocationDeleteDialog(false, subjectLocation, false, true)"

                                                        [disabled]="(selectedModel.locations.length === 1 && getLocationIndex(subjectLocation.identifier).length === 1) || isOffline">
                                                        {{'settingsSubject.delete' | translate }}</button>
                                                    <button mat-menu-item class="button-grouping" (click)="openEditLocationDialog(false,subjectLocation)"
                                                        [disabled]="(getLocationIndex(subjectLocation.identifier).length >= 3) || isOffline">
                                                        {{'settingsSubject.addNewLocation' | translate }}</button>
                                                    <button mat-menu-item (click)="locationRetention(subjectLocation, true)" [disabled]="isOffline">{{ 'settingsSubject.copyLocation' | translate }}</button>
                                                    <button mat-menu-item (click)="locationRetention(subjectLocation, false)" [disabled]="isOffline">{{ 'settingsSubject.cutLocation' | translate }}</button>
                                                    <button mat-menu-item (click)="validateIsUpdate(true, subjectLocation, null, false)" [disabled]="isDisablePaste(subjectLocation)"
                                                        [matTooltip]="getPasteTooltipText()">{{ 'settingsSubject.pasteLocation' | translate }}
                                                    </button>
                                                </mat-menu>
                                                <button mat-icon-button [matMenuTriggerFor]="ImageMenu" class="tree-button" style="display: inline !important;" (click)="$event.stopPropagation()"
                                                    *ngIf="selectedModel">
                                                    <mat-icon>more_vert</mat-icon>
                                                </button>
                                            </li>
                                        </mat-tree-node>

                                        <mat-nested-tree-node *matTreeNodeDef="let subjectLocation; when: hasNestedChild">
                                            <li>
                                                <div class="mat-tree-node"
                                                    [ngClass]="{'selected': selectedLocation && subjectLocation.identifier === selectedLocation.identifier}"
                                                    (click)="selectLocation4FilterImages(subjectLocation)">
                                                    <button mat-icon-button matTreeNodeToggle class="tree-button" style="width: 27px !important; height: 27px !important;"
                                                        [attr.aria-label]="'toggle ' + subjectLocation.name">
                                                        <mat-icon class="mat-icon-rtl-mirror">
                                                            {{nestedTreeControl.isExpanded(subjectLocation) ?
                                                            'expand_more'
                                                            : 'chevron_right'}}
                                                        </mat-icon>
                                                    </button>
                                                    <mat-icon class="folder-icon" [ngClass]="{'retention': isRetention(subjectLocation)}">folder</mat-icon>
                                                    <span [ngClass]="{'retention': isRetention(subjectLocation)}">{{subjectLocation.name}}</span>
                                                    <div fxFlex></div>
                                                    <mat-menu #ImageMenu="matMenu">
                                                        <button mat-menu-item (click)="openEditLocationDialog(true,subjectLocation)" [disabled]="isOffline">
                                                            {{'settingsSubject.editLocation' | translate }}</button>

                                                        <button mat-menu-item (click)="openLocationDeleteDialog(false, subjectLocation, false, true)"
                                                            [disabled]="(selectedModel.locations.length === 1 && getLocationIndex(subjectLocation.identifier).length === 1) || isOffline">
                                                            {{'settingsSubject.delete' | translate }}</button>
                                                        <button mat-menu-item class="button-grouping" (click)="openEditLocationDialog(false,subjectLocation)"
                                                            [disabled]="(!subjectLocation || getLocationIndex(subjectLocation.identifier).length >= 3) || isOffline">
                                                            {{'settingsSubject.addNewLocation' | translate }}</button>
                                                        <button mat-menu-item (click)="locationRetention(subjectLocation, true)" [disabled]="isOffline">{{ 'settingsSubject.copyLocation' | translate }}</button>
                                                        <button mat-menu-item (click)="locationRetention(subjectLocation, false)" [disabled]="isOffline">{{ 'settingsSubject.cutLocation' | translate }}</button>
                                                        <button mat-menu-item (click)="validateIsUpdate(true, subjectLocation, null, false)" [disabled]="isDisablePaste(subjectLocation)"
                                                            [matTooltip]="getPasteTooltipText()">{{ 'settingsSubject.pasteLocation' | translate }}
                                                        </button>
                                                    </mat-menu>
                                                    <button mat-icon-button [matMenuTriggerFor]="ImageMenu" class="tree-button"
                                                        (click)="$event.stopPropagation()" *ngIf="selectedModel">
                                                        <mat-icon>more_vert</mat-icon>
                                                    </button>
                                                </div>
                                                <ul [class.tree-invisible]="!nestedTreeControl.isExpanded(subjectLocation)">
                                                    <ng-container matTreeNodeOutlet></ng-container>
                                                </ul>
                                            </li>
                                        </mat-nested-tree-node>
                                    </mat-tree>
                                    <div fxFlex></div>
                                </div>
                            </div>

                        </mat-tab>

                        <mat-tab [label]="'settingsSubject.tabFolder' | translate">
                            <div class="download-button-area" fxLayoutAlign="end end" *ngIf="!isSafari(browserName)">
                                <button class="download-button" mat-button color="primary" (click)="downloadSubject()" [disabled]="isOffline">
                                    <mat-icon aria-label="">archive</mat-icon>{{ 'settingsSubject.downloadFolder' | translate }}
                                </button>
                            </div>
                            <mat-table [dataSource]="folderNameDataSource" class="foldername-table">
                                <ng-container matColumnDef="folderName">
                                    <mat-header-cell *matHeaderCellDef>{{ 'settingsSubject.folderName' | translate }}</mat-header-cell>
                                    <mat-cell *matCellDef="let row"> {{ row.hasChildren ? '' :
                                        row.location.folderName}}
                                        <p class="warning-message" *ngIf="row.location.folderName.length > 65">
                                            {{ 'settingsSubject.warningMaximumNumber' | translate }}</p>
                                    </mat-cell>
                                </ng-container>
                                <mat-header-row *matHeaderRowDef="['folderName']"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: ['folderName'];"></mat-row>
                            </mat-table>

                        </mat-tab>
                    </mat-tab-group>

                </div>
            </div>
        </div>
    </div>
</div>
